"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const noop = () => null;
const muiXTelemetryEvents = {
  licenseVerification: process.env.NODE_ENV === 'production' ? noop : (context, payload) => ({
    eventName: 'licenseVerification',
    payload,
    context
  })
};
var _default = exports.default = muiXTelemetryEvents;